import { Route, Routes } from "react-router-dom";
import React from "react";
import { PublicLandPrice } from "@/features/publicLandPrice/routes/PublicLandPrice";

export const PublicLandPriceRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="" element={<PublicLandPrice />} />
      <Route path="detail/:id" element={<PublicLandPrice />} />
    </Routes>
  );
};
